import { render, staticRenderFns } from "./PharmaceuticProfile.vue?vue&type=template&id=63785615&scoped=true"
import script from "./PharmaceuticProfile.vue?vue&type=script&lang=js"
export * from "./PharmaceuticProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63785615",
  null
  
)

export default component.exports